import classnames from 'classnames';

import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

import { toast } from 'react-toastify';

import { ReactComponent as CopySVG } from 'icons/copy.svg';

const PhoneNumber = ({
  name,
  label,
  disabled,
  valid,
  value,
  className,
  onChange,
  isCopiable = false,
}) => {
  const wrapperClasses = classnames('input-group', {
    error: !valid,
    [className]: className,
  });
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast('Copied to clipboard');
  };
  return (
    <div className={wrapperClasses}>
      <label data-cy={`${name}-label`}>{label}</label>

      <PhoneInput
        defaultCountry="fr"
        disabled={disabled}
        value={value || ''}
        onChange={onChange}
      />
      {!valid && (
        <span className="error">Please enter a valid phone number</span>
      )}
      {isCopiable && (
        <div
          style={{ top: '33px' }}
          data-rh="Copy"
          className="pointer absolute inset-y-0 right-0 flex items-center pr3"
          onClick={() => handleCopy()}
        >
          <CopySVG className="h5 w5 midgrey" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};

export default PhoneNumber;
